<template>
  <div
    v-if="visible"
    class="blocked-overlay"
    :class="`blocked-overlay--${layout}`"
    :style="offsetStyle"
  >
    <p class="blocked-overlay__title">
      Чтобы продолжить работу с заказами<br>
      необходимо <b>пополнить баланс</b>
    </p>

    <img
      class="blocked-overlay__lock"
      src="/img/account-blocked.png"
      alt=""
    >

    <div v-if="canUseBilling" class="blocked-overlay__actions">
      <v-btn
        v-if="promisedAvailable"
        class="blocked-overlay__btn"
        outlined
        large
        @click="goToTopup({ method: 'promised' })"
      >
        <v-icon left>
          mdi-clock-outline
        </v-icon>
        Обещанный платеж
      </v-btn>

      <v-btn
        class="blocked-overlay__btn"
        outlined
        large
        @click="goToTopup()"
      >
        <v-icon left>
          mdi-plus
        </v-icon>
        Пополнить
      </v-btn>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import RouteName from '@/models/enums/RouteName'

  export default {
    name: 'BlockedOverlay',
    props: {
      // 'default' — под шапкой и меню CRM, 'order' — в формах заказа, где шапки нет
      layout: {
        type: String,
        default: 'default',
        validator: (value) => ['default', 'order'].includes(value),
      },
    },
    computed: {
      ...mapState('billing', ['paymentAccount']),
      // Блокируем только работу с заказами, остальные разделы остаются доступны
      visible () {
        return this.billingBlocked && this.$route.meta?.blockedByBilling === true
      },
      promisedAvailable () {
        const promised = this.paymentAccount.promisedPayment
        return !!promised && promised.available && promised.termDays > 0
      },
      // Меню сворачивается, поэтому левый край считаем от его текущей ширины
      offsetStyle () {
        if (this.layout === 'order') return {}
        return { left: this.$store.state.app.mini ? '80px' : '260px' }
      },
    },
    methods: {
      goToTopup (query = {}) {
        this.$router.push({ name: RouteName.BillingTopup, query })
      },
    },
  }
</script>

<style lang="less" scoped>
.blocked-overlay {
  // Контент занимает высоту по содержимому, поэтому перекрываем окно, а не
  // родителя: сверху отступ на шапку (её высота задана в Header.vue), слева —
  // на меню, оно приходит в offsetStyle.
  position: fixed;
  top: 87px;
  right: 0;
  bottom: 0;
  z-index: 5;
  display: flex;
  // В формах заказа шапки нет, а справа степпер оформления (v-navigation-drawer,
  // z-index 6) — его тоже перекрываем, иначе заказ можно провести под оверлеем.
  &--order {
    top: 0;
    left: 260px;
    z-index: 7;

    // ширина меню заказа переключается по тому же порогу, что и в его Aside.vue
    @media (min-width: 1900px) {
      left: 326px;
    }
  }

  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  // цвет и размытие — из макета (Rectangle 224)
  background-color: #191919f5;
  backdrop-filter: blur(3.5px);
  text-align: center;

  &__title {
    margin: 0;
    font-size: 26px;
    line-height: 1.4;
    color: #fff;

    b {
      font-weight: 700;
    }
  }

  &__lock {
    width: 100%;
    max-width: 220px;
    height: auto;

    .media-xs({
      max-width: 140px;
    });
  }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px;
  }

  &__btn.v-btn {
    border-color: rgba(255, 255, 255, 0.7);
    color: #fff;
    border-radius: 4px;
    text-transform: none;
    letter-spacing: normal;
    font-size: 15px;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }
}
</style>
